// "1": "Fasadni zid",
// "5": "Ravan krov",
// "7": "Kos krov",
// "18": "Plafon ispod negrejanog tavana",
// "19": "Pod iznad negrejanog podruma",
// "20": "Zid u tlu",
// "21": "Pod na tlu",
// "30": "Zid u potkrovlju",
// "10": "Prozori",
// "13": "Vrata",
// "60": "Krovni prozori"

// import _ from "lodash";

import maxu from "./maxu.js";
import helpers from "./helpers.js";
import superconsole from "./superconsole.js";
import settings from "../Settings.js";
import mixin from "../lib/mixins.js";
import mixins from "../lib/mixins.js";


/* 
  Za preracunavanje U vrednosti prvobitnog stanja koristiti lambda_original
  za preracunavanje U vrednosti stanja sa dodatom izolacijom koristiti lambda_new
 */
const lambda_original = 0.04;
const lambda_new = 0.9 * lambda_original;

export const transformCoordinates = (x, y, z) => {
  const alpha = Math.atan2(z, x);
  const beta = Math.atan2(Math.sqrt(x * x + z * z), y);
  const radius = Math.sqrt(x * x + y * y + z * z);
  return { alpha, beta, radius };
};

const round = function (numb, precision) {
  return Math.round(numb * 10 ** precision) / 10 ** precision;
};

const middle = function (value) {
  if (value === 0) return 0;
  return Math.ceil(value / 2) - 1;
};

const area_etaza = function (povrsina, spratovi) {
  return (povrsina / spratovi) * 1.3;
};

const strana_etaza = function (povrsina_sprata) {
  return Math.sqrt(povrsina_sprata);
};

const povrsina_krova = function (duzina_strane_kuce, visina_potkrovlje) {
  return Math.sqrt(Math.pow(duzina_strane_kuce / 2, 2) + Math.pow(visina_potkrovlje, 2)) * 2 * duzina_strane_kuce;
};
export default {
  lambda_new: lambda_new,
  round: round,
  middle: middle,
  get_max_u: maxu.get_max_u,
  get_standard_data_array: maxu.get_standard_data_array,
  get_calculate_bottom_debljina: maxu.get_calculate_bottom_debljina,
  numberWithCommas: function (value, max_digits = 2, min_digits = 2) {
    return value.toLocaleString(settings.country, {
      minimumFractionDigits: min_digits,
      maximumFractionDigits: max_digits,
    });
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  get_hdd: function (internal, ta, hd, hdd_ref, ti_ref) {
    if ((ta === -1 || hd === -1) && hdd_ref !== -1 && ti_ref !== -1) {
      return Math.round((hdd_ref * internal) / ti_ref);
    } else if (ta !== -1 && hd !== -1) {
      return Math.round((internal - ta) * hd);
    } else {
      return 0;
    }
  },

  get_povrsine: function (
    grejana_povrsina,
    broj_grejanih_spratova,
    visina_sprat,
    visina_potkrovlje,
    tip_potkrovlje, // 1 - grejano, 0 - negrejano, -1 ne postoji
    tip_podrum, // 1 - grejano, 0 - negrejano, -1 ne postoji
    dubina_ukopavanja,
    typ_override_window,
    typ_override_window_manual,
    typ_override_roof_window,
    typ_override_roof_window_manual
  ) {
    visina_sprat -= 0.31;
    let final = { A: {}, B: {} };
    let total_grejanih_spratova = broj_grejanih_spratova;
    if (tip_potkrovlje === 1) total_grejanih_spratova++;
    if (tip_podrum === 1) total_grejanih_spratova++;

    final.povrsina_jednog_sprata = area_etaza(grejana_povrsina, total_grejanih_spratova);
    final.duzina_strane_kuce = strana_etaza(final.povrsina_jednog_sprata);

    final.grejana_fasadna_visina_kuce = visina_sprat * broj_grejanih_spratova;
    if (tip_potkrovlje === 1) final.grejana_fasadna_visina_kuce += visina_potkrovlje * 0.6;
    if (tip_podrum === 1) final.grejana_fasadna_visina_kuce += Math.max(visina_sprat - dubina_ukopavanja, 0);

    final.grejana_zapreminska_visina_kuce = visina_sprat * broj_grejanih_spratova;
    if (tip_potkrovlje === 1) final.grejana_zapreminska_visina_kuce += visina_potkrovlje * 0.7;
    if (tip_podrum === 1) final.grejana_zapreminska_visina_kuce += visina_sprat;

    final.grejana_zapremina_kuce = (final.grejana_zapreminska_visina_kuce * grejana_povrsina) / total_grejanih_spratova;

    final.grejana_fasadna_povrsina_zidova = final.duzina_strane_kuce * 4 * final.grejana_fasadna_visina_kuce;
    final.povrsina_prozora = typ_override_window_manual
      ? typ_override_window
      : final.grejana_fasadna_povrsina_zidova / 6;
    // fasada
    final.A["1"] = final.grejana_fasadna_povrsina_zidova - final.povrsina_prozora;
    // prozori
    final.A["10"] = round(final.povrsina_prozora, 0);
    // vrata
    final.A["13"] = 2.5;

    if (tip_potkrovlje === -1) {
      // ravan krov
      final.A["5"] = final.povrsina_jednog_sprata;
      final.A["7"] = 0;
      final.A["18"] = 0;
      final.A["60"] = 0;
    } else if (tip_potkrovlje === 0) {
      // tavan
      final.A["18"] = final.povrsina_jednog_sprata;
      final.A["5"] = 0;
      final.A["7"] = 0;
      final.A["60"] = 0;
    } else if (tip_potkrovlje === 1) {
      // grejano potkrovlje
      final.povrsina_krova_kuce = povrsina_krova(final.duzina_strane_kuce, visina_potkrovlje);
      final.povrsina_krovnih_prozora = typ_override_roof_window_manual
        ? typ_override_roof_window
        : final.povrsina_krova_kuce / 10;
      final.A["7"] = final.povrsina_krova_kuce - final.povrsina_krovnih_prozora;
      final.A["60"] = round(final.povrsina_krovnih_prozora, 0);
      final.A["5"] = 0;
      final.A["18"] = 0;
    }

    if (tip_podrum === -1) {
      // nema podruma
      final.A["21"] = final.povrsina_jednog_sprata;
      final.A["19"] = 0;
      final.A["20"] = 0;
    } else if (tip_podrum === 0) {
      // negrejani podrum
      final.A["19"] = final.povrsina_jednog_sprata;
      final.A["20"] = 0;
      final.A["21"] = 0;
    } else if (tip_podrum === 1) {
      // grejani podrum
      final.A["20"] = final.duzina_strane_kuce * 4 * dubina_ukopavanja;
      final.A["21"] = final.povrsina_jednog_sprata;
      final.A["19"] = 0;
    }

    // zid u potkrovlju
    // todo
    final.A["30"] = 0;
    final.A["povrsina_jednog_sprata"] = final.povrsina_jednog_sprata;
    final.B = {
      1: final.A["1"],
      5: final.A["5"],
      7: final.A["7"],
      18: final.A["18"] / 1.3,
      19: final.A["19"] / 1.3,
      20: final.A["20"],
      21: final.A["21"] / 1.3,
      30: final.A["30"],
      10: final.A["10"],
      13: final.A["13"],
      60: final.A["60"],
    };
    final.B["povrsina_jednog_sprata"] = final.povrsina_jednog_sprata / 1.3;
    return final;
  },
  get_final_existing_U: function (start_U, start_D, final_D, lambda_used = lambda_original) {
    // all values in meters
    const r_u = 1 / start_U;
    superconsole.log("r_u = 1 / start_U");
    superconsole.log("r_u = 1 / ", start_U);
    superconsole.log("r_u = ", r_u);

    const r_d = (final_D - start_D) / lambda_used;
    superconsole.log("r_d = (final_D - start_D) / lambda_used");
    superconsole.log("r_d = (", final_D, " - ", start_D, ") / ", lambda_used, ")");
    superconsole.log("r_d = ", r_d);

    const sum_r = r_u + r_d;
    superconsole.log("sum_r = r_u + r_d");
    superconsole.log("sum_r = ", r_u, " + ", r_d);
    superconsole.log("sum_r = ", sum_r);

    const res = 1 / sum_r;
    superconsole.log("rezultat = 1 / ", sum_r);
    superconsole.log("rezultat = 1 / ", sum_r);
    superconsole.log("rezultat = ", res);
    return res;
  },

  /**
   * Racuna U vrednosti za poziciju koju odredjuje key i vraca ih u objektu koji sadrzi
   * U vrednosti pre intervencije i nakon dodavanja izolacije:
   * {
   *   "u": {
   *     "top": {                 vrednost pre dodavanja izolacije (koristi lambda_original)
   *       "default": 1.4,
   *       "current": 1.4
   *     },
   *     "bottom": {              vrednost nakon dodavanja izolacije (koristi lambda_new)
   *       "current": 1.4
   *     }
   *   }
   * }
   * 
   * @param {number} key 
   * @param {object} data 
   * @param {object} status 
   * @param {number} debljina_zida 
   * @param {number} top_debljina_izolacije_default 
   * @param {object} typ_vrstatla 
   * @param {object} typ_dubina 
   * @param {number} povrsina_jednog_sprata 
   * @param {number} duzina_strane_kuce 
   * @param {object} pos_status_21 
   * @param {boolean} all (default true)
   * @param {*} top_sklop 
   * @returns 
   */
  get_final_u: function (
    key,
    data,
    status,
    debljina_zida,
    top_debljina_izolacije_default,
    typ_vrstatla,
    typ_dubina,
    povrsina_jednog_sprata,
    duzina_strane_kuce,
    pos_status_21,
    all = true,
    top_sklop
  ) {
    function get_u_zida(
      debljina_zida_kuce,
      debljina_izolacije_zida,
      debljina_izolacije_poda,
      lambda_used = lambda_original
    ) {
      debljina_zida_kuce = debljina_zida_kuce === 0 ? 0.38 : debljina_zida_kuce;
      let lambda_tla = typ_vrstatla.value;
      superconsole.log("lambda_tla = ", typ_vrstatla.value);
      let dubina_ukopavanja = typ_dubina.value;
      superconsole.log("dubina_ukopavanja = ", typ_dubina.value);
      let u_poda, u_zida;
      const Bprim = povrsina_jednog_sprata / (2 * duzina_strane_kuce);
      superconsole.log("Bprim = povrsina_jednog_sprata / (2 * duzina_strane_kuce)");
      superconsole.log("Bprim = ", povrsina_jednog_sprata, " / (2 * ", duzina_strane_kuce, " )");
      superconsole.log("Bprim = ", Bprim);
      const Rsi = 0.13;
      superconsole.log("Rsi = ", 0.13);
      const Rse = 0;
      superconsole.log("Rse = ", 0);
      const Rw = debljina_izolacije_zida / lambda_used;
      superconsole.log("Rw = debljina_izolacije_zida / lambda_used");
      superconsole.log("Rw = ", debljina_izolacije_zida, " / ", lambda_used);
      superconsole.log("Rw = ", Rw);
      const Rf = debljina_izolacije_poda / lambda_used;
      superconsole.log("Rf = debljina_izolacije_poda / lambda_used");
      superconsole.log("Rf = ", debljina_izolacije_poda, " / ", lambda_used);
      superconsole.log("Rf = ", Rf);
      const dw = lambda_tla * (Rsi + Rse + Rw);
      superconsole.log("dw = lambda_tla * (Rsi + Rse + Rw)");
      superconsole.log("dw = lambda_tla * (Rsi + Rse + Rw)");
      superconsole.log("dw = ", dw);
      const dt = debljina_zida_kuce + lambda_tla * (Rsi + Rse + Rf);
      superconsole.log("dt = ", debljina_zida_kuce, " + ", lambda_tla, " * (", Rsi, " + ", Rse, " + ", Rf, ")");
      superconsole.log("dt = ", debljina_zida_kuce, " + ", lambda_tla, " * (", Rsi, " + ", Rse, " + ", Rf, ")");
      superconsole.log("dt = ", dt);
      if (dt + 0.5 * dubina_ukopavanja < Bprim) {
        superconsole.log("dt + 0.5 * dubina_ukopavanja < Bprim");
        u_poda =
          ((2 * lambda_tla) / (Math.PI * Bprim + dt + 0.5 * dubina_ukopavanja)) *
          Math.log((Math.PI * Bprim) / (dt + 0.5 * dubina_ukopavanja) + 1);
        superconsole.log(`u_poda =
          ((2 * lambda_tla) / (Math.PI * Bprim + dt + 0.5 * dubina_ukopavanja)) *
          Math.log((Math.PI * Bprim) / (dt + 0.5 * dubina_ukopavanja) + 1)`);
        superconsole.log("u_poda =", u_poda);
      } else {
        superconsole.log("dt + 0.5 * dubina_ukopavanja >= Bprim");
        u_poda = lambda_tla / (0.457 * Bprim + dt + 0.5 * dubina_ukopavanja);
        superconsole.log(`u_poda = lambda_tla / (0.457 * Bprim + dt + 0.5 * dubina_ukopavanja)`);
        superconsole.log("u_poda =", u_poda);
      }
      if (dw >= dt) {
        superconsole.log("dw >= dt");
        u_zida =
          ((2 * lambda_tla) / (Math.PI * dubina_ukopavanja)) *
          (1 + (0.5 * dt) / (dt + dubina_ukopavanja)) *
          Math.log(dubina_ukopavanja / dw + 1);
        superconsole.log(`u_zida =
          ((2 * lambda_tla) / (Math.PI * dubina_ukopavanja)) *
          (1 + (0.5 * dt) / (dt + dubina_ukopavanja)) *
          Math.log(dubina_ukopavanja / dw + 1)`);
        superconsole.log("u_zida =", u_zida);
      } else {
        superconsole.log("dw < dt");
        u_zida =
          ((2 * lambda_tla) / (Math.PI * dubina_ukopavanja)) *
          (1 + (0.5 * dw) / (dw + dubina_ukopavanja)) *
          Math.log(dubina_ukopavanja / dw + 1);
        superconsole.log(`u_zida =
          ((2 * lambda_tla) / (Math.PI * dubina_ukopavanja)) *
          (1 + (0.5 * dw) / (dw + dubina_ukopavanja)) *
          Math.log(dubina_ukopavanja / dw + 1)`);
        superconsole.log("u_zida =", u_zida);
      }
      return { u_poda, u_zida };
    }

    function get_u_poda(debljina_zida_kuce, debljina_izolacije_poda, lambda_used = lambda_original) {
      debljina_zida_kuce = debljina_zida_kuce === 0 ? 0.38 : debljina_zida_kuce;
      let lambda_tla = typ_vrstatla.value;
      let u_poda;
      const Bprim = povrsina_jednog_sprata / (2 * duzina_strane_kuce);
      const Rsi = 0.17;
      const Rse = 0;
      const Rf = debljina_izolacije_poda / lambda_used;
      const dt = debljina_zida_kuce + lambda_tla * (Rsi + Rse + Rf);
      if (dt < Bprim) {
        u_poda = ((2 * lambda_tla) / (Math.PI * Bprim + dt)) * Math.log((Math.PI * Bprim) / dt + 1);
      } else {
        u_poda = lambda_tla / (0.457 * Bprim + dt);
      }
      return u_poda;
    }

    function get_sklop(
      local_top_sklop,
      local_data,
      top_image,
      local_debljina_zida,
      local_top_debljina_izolacije_default,
      lambda_used = lambda_original
    ) {
      if (local_top_sklop) return local_top_sklop;

      if (local_data[top_image + "_" + local_debljina_zida + "_" + local_top_debljina_izolacije_default])
        return local_data[top_image + "_" + local_debljina_zida + "_" + local_top_debljina_izolacije_default];

      if (local_top_debljina_izolacije_default == 1 && local_data[top_image + "_" + local_debljina_zida + "_" + 0]) {
        // res sadrzi vrednost U koja nije preracunata, vec iz bigknauf-a :D (App.vue data.app_sklopovi.data -> defdata.app_sklopovi -> aplikacija.sklopovi)
        let res = { ...local_data[top_image + "_" + local_debljina_zida + "_" + 0] };
        const r_u = 1 / res.u;
        const r_d = 0.01 / lambda_used;
        const sum_r = r_u + r_d;
        res.u = round(1 / sum_r, 2);
        superconsole.log("calculating fake isolation");
        return res;
      }
      if (local_data[top_image + "_" + local_debljina_zida]) return local_data[top_image + "_" + local_debljina_zida];
      if (local_data[top_image]) return local_data[top_image];
      const kljucevi = Object.keys(local_data);
      const startkey = top_image + "_" + local_debljina_zida;
      const sklopovi = kljucevi.filter((elem) => elem.startsWith(startkey));
      if (sklopovi.length != 0) {
        const sklop = local_data[sklopovi[0]];
        sklop.local_top_debljina_izolacije_default = sklopovi[0].substring(startkey.length + 1) / 100;
        return sklop;
      }

      throw "Sklop not found exception";
    }

    const u = { top: { default: NaN, current: NaN }, bottom: { current: NaN } };
    let u_21;
    // superconsole.log(status);
    // superconsole.log(data);
    // superconsole.log(status.top_image);
    // superconsole.log(status.top_image + "_" + debljina_zida);
    if (key == "1" || key == "5" || key == "7" || key == "18" || key == "19") {
      const sklop = get_sklop(top_sklop, data, status.top_image, debljina_zida, top_debljina_izolacije_default);
      const sklop_new = get_sklop(top_sklop, data, status.top_image, debljina_zida, top_debljina_izolacije_default, lambda_new);
      superconsole.info(`%cpozicija ${key}`, "color: yellow");
      superconsole.info(`%cpostojece stanje`, "color: yellow");
      superconsole.info(`%csklop ${status.top_image}`, "color: yellow");
      u.top.current = this.get_final_existing_U(
        sklop.u,
        sklop["top_debljina_izolacije_default"] != null
          ? sklop["top_debljina_izolacije_default"]
          : status.top_debljina_izolacije_default,
        status.top_debljina_izolacije
      );

      if (all) {
        u.top.default = sklop.u;
        superconsole.info(`%cpozicija ${key}`, "color: yellow");
        superconsole.info(`%cstanje nakon intervencije`, "color: yellow");
        u.bottom.current = this.get_final_existing_U(
          sklop_new.u,
          sklop_new["top_debljina_izolacije_default"] != null
            ? sklop_new["top_debljina_izolacije_default"]
            : status.top_debljina_izolacije_default,
          status.top_debljina_izolacije + status.bottom_debljina_izolacije,
          lambda_new
        );
      }
    } else if (key == "10" || key == "13" || key == "60") {
      u.top.current = data[status.top_image].u;

      if (all) {
        u.top.default = data[status.top_image].u;
        /*
          Prozori i vrata (pos 10 i 13) nemaju naknadnu izolaciju.
          status.bottom_image dobija vrednost samo ako se aktivno odaberu
          prozori ili vrata.
          data[status.bottom_image].u je vrednost iz bigknauf > Konstrukcije_U
          (nikakvo preracunavanje se ne desava izmedju)
         */
        u.bottom.current = data[status.bottom_image] ? data[status.bottom_image].u : 0;
      }
    } else if (key == "20") {
      superconsole.info(`%cpozicija ${key}`, "color: yellow");
      superconsole.info(`%cpostojece stanje`, "color: yellow");
      superconsole.info(`%csklop ${status.top_image}`, "color: yellow");
      let temp;
      u_21 = { top: { default: NaN, current: NaN }, bottom: { current: NaN } };
      // postojece stanje ^^ => lambda_original (default)
      temp = get_u_zida(status.top_debljina_zida, status.top_debljina_izolacije, pos_status_21.top_debljina_izolacije);
      u.top.current = temp.u_zida;
      u_21.top.current = temp.u_poda;

      if (all) {
        superconsole.info(`%cpozicija ${key}`, "color: yellow");
        superconsole.info(`%cstanje nakon intervencije`, "color: yellow");
        superconsole.info(`%csklop ${status.top_image}`, "color: yellow");
        /*
          log "stanje nakon intervencije" ^^,
          ALI u.top.current je za stanje pre, a i u.top.default za ostale
          konstrukcije ^^^ ukazuje na stanje pre. Pri tom top.default se nigde
          ne koristi, samo se dodeljuje vrednost => proveriti sa Vladom;
          => koristim lambda_original
         */
        temp = get_u_zida(
          status.top_debljina_zida,
          status.top_debljina_izolacije_default,
          pos_status_21.top_debljina_izolacije_default
        );
        u.top.default = temp.u_zida;
        u_21.top.default = temp.u_poda;

        // bottom.current == stanje SA izolacijom => lambda_new
        temp = get_u_zida(
          status.top_debljina_zida,
          status.top_debljina_izolacije + status.bottom_debljina_izolacije,
          pos_status_21.top_debljina_izolacije + pos_status_21.bottom_debljina_izolacije,
          lambda_new
        );

        u.bottom.current = temp.u_zida;
        u_21.bottom.current = temp.u_poda;
      }
    } else if (key == "21") {
      u.top.current = get_u_poda(status.top_debljina_zida, status.top_debljina_izolacije);
      if (all) {
        u.top.default = get_u_poda(status.top_debljina_zida, status.top_debljina_izolacije_default);
        // sa dodatom izolacijom => lambda_new
        u.bottom.current = get_u_poda(status.top_debljina_zida, status.bottom_debljina_izolacije, lambda_new);
      }
    }

    return { u, u_21 };
  },
  mixins: [mixin],
  get_final_calculation: function (
    typ_stanje_value,
    get_povrsine,
    get_pos_status_u,
    loc_HDD_value,
    loc_wind_value,
    app_sklopovi_default_data,
    typ_constdate_value,
    get_sklopovi_data_sklopovi,
    app_sklopovi_data,
    loc_hd_value,
    typ_floorarea_value,
    loc_sun_value,
    loc_zone_value,
    loc_country_value,
    pos_status_value,
    typ_grejanje,
    typ_grejanje_cena_data,
    typ_grejanje_cena_data_cfg,
    typ_ceiling_value
  ) {
    const f_value = {
      "1": 1,
      "5": 1,
      "7": 1,
      "18": 0.8,
      "19": 0.5,
      "20": 0.6,
      "21": 0.5,
      "30": 1,
      "10": 1,
      "13": 1,
      "60": 1,
    };

    function get_solar_correction() {
      if (loc_sun_value === 1) {
        return 0.9;
      } else if (loc_sun_value === 2) {
        return 0.75;
      } else {
        return 0.6;
      }
    }

    function get_window_correction(u) {
      if (get_povrsine.grejana_fasadna_povrsina_zidova / 7 > get_povrsine.povrsina_prozora) {
        // MALA
        if (u > 3) return 0.14;
        if (u < 2) return 0.1;
        return 0.12;
      } else if (get_povrsine.grejana_fasadna_povrsina_zidova / 5 < get_povrsine.povrsina_prozora) {
        // VELIKA
        if (u > 3) return 0.18;
        if (u < 2) return 0.14;
        return 0.16;
      } else {
        // SREDNJA
        if (u > 3) return 0.16;
        if (u < 2) return 0.12;
        return 0.14;
      }
    }

    function sumUAF(tip) {
      let print = [["Pozicija", "A", "U", "F"]];
      let sum = 0;
      for (const key in get_pos_status_u) {
        if (get_pos_status_u.hasOwnProperty(key)) {
          const element = get_pos_status_u[key];
          const A = get_povrsine["A"][key];
          const F = f_value[key];
          /*
            - Za stanje pre izolacije (tip 1)
                koristi se vrednost U top.current;
            - za stanje posle
                . ako je definitivno primenjena izolacija (klik na dugme "potvrdi poziciju")
                  (pos_status_value[key].status == 1)
                    koristi se bottom.current;
                . ako izolacija nije primenjena
                    koristi se top.current
          */
          const U =
            tip === 1
              ? element.top.current
              : pos_status_value[key].status == 1
              ? element.bottom.current
              : element.top.current;
          sum += A * U * F;
          print.push([key, A, U, F]);
        }
      }

      superconsole.log(tip === 1 ? "existing" : "new");

      superconsole.table(print);
      return sum;
    }
    

    function sumA() {
      let sum = 0;
      for (const key in get_pos_status_u) {
        if (get_pos_status_u.hasOwnProperty(key)) {
          sum += 0.1 * get_povrsine["A"][key];
        }
      }
      return sum;
    }

    function get_korekcija_dobici() {
      let krov_konstrukcija = get_laka_konstrukcija_data(7);
      let zid_konstrukcija = get_laka_konstrukcija_data(1);
      if (!zid_konstrukcija) return 0.9;
      if (!krov_konstrukcija) return 0.98;
      return 1;
    }

    function get_laka_konstrukcija_data(pozicija) {
      if (get_pos_status_u[pozicija]) {
        return pos_status_value[pozicija].laka_konstrukcija;
      } else {
        const res = helpers.get_default_sklop(
          typ_stanje_value,
          app_sklopovi_default_data,
          pozicija,
          typ_constdate_value,
          get_sklopovi_data_sklopovi,
          typ_ceiling_value,
          loc_country_value
        );

        return helpers.get_top_sklop_data(
          app_sklopovi_data,
          res.image,
          res.debljina_zida,
          res.debljina_izolacije_default
        ).laka_konstrukcija;
      }
    }

    function get_prozor_data(tip) {
      if (get_pos_status_u[10]) {
        return tip === 1
          ? get_pos_status_u[10].top.current
          : pos_status_value[10].status == 1
          ? get_pos_status_u[10].bottom.current
          : get_pos_status_u[10].top.current;
      } else {
        const res = helpers.get_default_sklop(
          typ_stanje_value,
          app_sklopovi_default_data,
          "10",
          typ_constdate_value,
          get_sklopovi_data_sklopovi,
          typ_ceiling_value,
          loc_country_value
        );

        return helpers.get_top_sklop_data(
          app_sklopovi_data,
          res.image,
          res.debljina_zida,
          res.debljina_izolacije_default
        ).u;
      }
    }

    function broj_izmena_vazduha(u) {
      if (u < 2) {
        return 0.5;
      } else if (u >= 2 && u <= 3) {
        if (loc_wind_value === 1) {
          return 0.8;
        } else if (loc_wind_value === 2) {
          return 0.6;
        } else {
          return 0.5;
        }
      } else {
        if (loc_wind_value === 1) {
          return 1.5;
        } else if (loc_wind_value === 2) {
          return 1;
        } else {
          return 0.76;
        }
      }
    }

    function get_energetski_razred(energija) {
      superconsole.log("%cObracun energetskog razreda", "color: yellow");

      const faktor = energija / typ_floorarea_value;
      superconsole.log("faktor = energija / typ_floorarea_value");
      superconsole.log("faktor = ", energija, " / ", typ_floorarea_value);
      superconsole.log("faktor = ", faktor);
      if (typ_stanje_value === 1) {
        superconsole.log("Kuca je postojeca");
        superconsole.log("Matematika za razred");
        superconsole.log(`if (faktor < 12) return "A+";
        if (faktor < 20) return "A";
        if (faktor < 38) return "B";
        if (faktor < 75) return "C";
        if (faktor < 113) return "D";
        if (faktor < 150) return "E";
        if (faktor <= 188) return "F";
        return "G"`);

        // postojeca
        if (faktor < 12) return "A+";
        if (faktor < 20) return "A";
        if (faktor < 38) return "B";
        if (faktor < 75) return "C";
        if (faktor < 113) return "D";
        if (faktor < 150) return "E";
        if (faktor <= 188) return "F";
        return "G";
      } else {
        superconsole.log("Kuca je nova");
        superconsole.log("Matematika za razred");
        superconsole.log(`if (faktor < 10) return "A+";
        if (faktor < 17) return "A";
        if (faktor < 33) return "B";
        if (faktor < 65) return "C";
        if (faktor < 98) return "D";
        if (faktor < 130) return "E";
        if (faktor <= 163) return "F";
        return "G"`);
        // nova
        if (faktor < 10) return "A+";
        if (faktor < 17) return "A";
        if (faktor < 33) return "B";
        if (faktor < 65) return "C";
        if (faktor < 98) return "D";
        if (faktor < 130) return "E";
        if (faktor <= 163) return "F";
        return "G";
      }
    }

    /* Kalkulacija:
        final.existing    pocetno stanje
        final.new         stanje sa novom izolacijom
     */
    const final = { existing: {}, new: {}, dobici: {} };
    const prozor_u_existing = get_prozor_data(1);
    const prozor_u_new = get_prozor_data(2);
    const dobici_korekcija = get_korekcija_dobici();
    let temp;

    /*
      Izracunavanje postojeceg stanja
     */
    temp = final.existing;

    superconsole.log("sumUAF(1) = ", sumUAF(1));
    superconsole.log("0.1 * sumA() = ", sumA());

    superconsole.log("sumUAF(1)");
    temp.HT = sumUAF(1) + sumA();

    superconsole.log("sumUAF(1) + 0.1 * sumA()");

    superconsole.log("HT = ", temp.HT);
    temp.QHT = (temp.HT * loc_HDD_value * 24) / 1000;

    superconsole.log("QHT = (temp.HT * loc_HDD_value * 24) / 1000");

    superconsole.log("QHT = (", temp.HT, " * ", loc_HDD_value, " * 24) / 1000");

    superconsole.log("QHT = ", temp.QHT);
    temp.HV = 0.33 * get_povrsine.grejana_zapremina_kuce * broj_izmena_vazduha(prozor_u_existing);

    superconsole.log("HV = 0.33 * get_povrsine.grejana_zapremina_kuce * broj_izmena_vazduha(prozor_u_existing)");

    superconsole.log(
      "HV = 0.33 * ",
      get_povrsine.grejana_zapremina_kuce,
      " * ",
      broj_izmena_vazduha(prozor_u_existing)
    );

    superconsole.log("HV = ", temp.HV);
    temp.QHV = (temp.HV * loc_HDD_value * 24) / 1000;

    superconsole.log("QHV = (temp.HV * loc_HDD_value * 24) / 1000");

    superconsole.log("QHV = (", temp.HV, " * ", loc_HDD_value, " * 24) / 1000");

    superconsole.log("QHV = ", temp.QHV);
    temp.Q = temp.QHT + temp.QHV;

    superconsole.log("Q = temp.QHT + temp.QHV;");

    superconsole.log("Q = ", temp.QHT, " + ", temp.QHV);

    superconsole.log("Q = ", temp.Q);
    temp.sun =
      get_solar_correction() *
      get_window_correction(prozor_u_existing) *
      temp.Q *
      maxu.get_solar_radiation(loc_country_value, loc_zone_value);

    superconsole.log(
      "get_solar_correction() * get_window_correction(prozor_u_existing) * temp.Q * maxu.get_solar_radiation(loc_country_value, loc_zone_value)"
    );

    superconsole.log(
      get_solar_correction(),
      " * ",
      get_window_correction(prozor_u_existing),
      " * ",
      temp.Q,
      " * ",
      maxu.get_solar_radiation(loc_country_value, loc_zone_value)
    );

    superconsole.log("sun = ", temp.sun);
    temp.ljudi = 0.024 * loc_hd_value * 5 * typ_floorarea_value;

    superconsole.log("ljudi = 0.024 * loc_hd_value * 5 * typ_floorarea_value");

    superconsole.log("ljudi = 0.024 * ", loc_hd_value, " * 5 * ", typ_floorarea_value);

    superconsole.log("ljudi = ", temp.ljudi);
    temp.dobici_korekcija = dobici_korekcija;

    superconsole.log("koeficijenat_iskoriscenja = ", dobici_korekcija);
    temp.final = temp.Q - dobici_korekcija * (temp.sun + temp.ljudi);

    superconsole.log("potrebna_energija = temp.Q - koeficijenat_iskoriscenja * (temp.sun + temp.ljudi)");

    superconsole.log("potrebna_energija = ", temp.Q, " - ", dobici_korekcija, " * (", temp.sun, " + ", temp.ljudi, ")");

    superconsole.log("potrebna_energija = ", temp.final);
    temp.energetski_razred = get_energetski_razred(temp.final);
    temp.grejanje_gubici = temp.final * (1 - typ_grejanje.data[typ_grejanje.value].korisnost);

    superconsole.log(
      "grejanje_gubici = temp.potrebna_energija * (1 - typ_grejanje.data[typ_grejanje.value].korisnost)"
    );

    superconsole.log(
      "grejanje_gubici = ",
      temp.final,
      " * (1 - ",
      typ_grejanje.data[typ_grejanje.value].korisnost,
      ")"
    );

    superconsole.log("grejanje_gubici = ", temp.grejanje_gubici);
    temp.final_grejanje = temp.final + temp.grejanje_gubici;

    superconsole.log("final_grejanje = temp.potrebna_energija + temp.grejanje_gubici;");

    superconsole.log("final_grejanje = ", temp.final, " + ", temp.grejanje_gubici);

    superconsole.log("final_grejanje = ", temp.final_grejanje);
    temp.primarno_grejanje =
      temp.final_grejanje * maxu.get_heating_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip);

    superconsole.log(
      "primarno_grejanje = temp.final_grejanje * maxu.get_heating_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip)"
    );

    superconsole.log(
      "primarno_grejanje = ",
      temp.final_grejanje,
      " * ",
      maxu.get_heating_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip)
    );

    superconsole.log("primarno_grejanje = ", temp.primarno_grejanje);
    temp.co2 =
      temp.primarno_grejanje * maxu.get_co2_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip);

    temp.cena = temp.final_grejanje * mixins.data().typ_grejanje_cena_data_cfg[typ_grejanje.value];
    
    /* 
      Izracunavanje stanja sa novom izolacijom
     */
    temp = final.new;
    temp.HT = sumUAF(2) + sumA();

    superconsole.log("HT = sumUAF(2) + sumA()");
    

    superconsole.log("HT = ", temp.HT);
    temp.QHT = (temp.HT * loc_HDD_value * 24) / 1000;

    superconsole.log("QHT = (temp.HT * loc_HDD_value * 24) / 1000");

    superconsole.log("QHT = (", temp.HT, " * ", loc_HDD_value, " * 24) / 1000");

    superconsole.log("QHT = ", temp.QHT);
    temp.HV = 0.33 * get_povrsine.grejana_zapremina_kuce * broj_izmena_vazduha(prozor_u_new);

    superconsole.log("HV = 0.33 * get_povrsine.grejana_zapremina_kuce * broj_izmena_vazduha(prozor_u_new)");

    superconsole.log("HV = 0.33 * ", get_povrsine.grejana_zapremina_kuce, " * ", broj_izmena_vazduha(prozor_u_new));

    superconsole.log("HV = ", temp.HV);
    temp.QHV = (temp.HV * loc_HDD_value * 24) / 1000;

    superconsole.log("QHV = (temp.HV * loc_HDD_value * 24) / 1000");

    superconsole.log("QHV = (", temp.HV, " * ", loc_HDD_value, " * 24) / 1000");

    superconsole.log("QHV = ", temp.QHV);
    temp.Q = temp.QHT + temp.QHV;

    superconsole.log("Q = temp.QHT + temp.QHV;");

    superconsole.log("Q = ", temp.QHT, " + ", temp.QHV);

    superconsole.log("Q = ", temp.Q);
    temp.sun =
      get_solar_correction() *
      get_window_correction(prozor_u_new) *
      final.existing.Q *
      maxu.get_solar_radiation(loc_country_value, loc_zone_value);

    superconsole.log(
      "get_solar_correction() * get_window_correction(prozor_u_new) * existing.Q * maxu.get_solar_radiation(loc_country_value, loc_zone_value)"
    );

    superconsole.log(
      get_solar_correction(),
      " * ",
      get_window_correction(prozor_u_new),
      " * ",
      final.existing.Q,
      " * ",
      maxu.get_solar_radiation(loc_country_value, loc_zone_value)
    );

    superconsole.log("sun = ", temp.sun);
    temp.ljudi = 0.024 * loc_hd_value * 5 * typ_floorarea_value;

    superconsole.log("ljudi = 0.024 * loc_hd_value * 5 * typ_floorarea_value");

    superconsole.log("ljudi = 0.024 * ", loc_hd_value, " * 5 * ", typ_floorarea_value);

    superconsole.log("ljudi = ", temp.ljudi);
    temp.dobici_korekcija = dobici_korekcija;

    superconsole.log("koeficijenat_iskoriscenja = ", dobici_korekcija);
    temp.final = temp.Q - dobici_korekcija * (temp.sun + temp.ljudi);

    superconsole.log("potrebna_energija = temp.Q - koeficijenat_iskoriscenja * (temp.sun + temp.ljudi)");

    superconsole.log("potrebna_energija = ", temp.Q, " - ", dobici_korekcija, " * (", temp.sun, " + ", temp.ljudi, ")");

    superconsole.log("potrebna_energija = ", temp.final);
    temp.energetski_razred = get_energetski_razred(temp.final);
    temp.grejanje_gubici = temp.final * (1 - typ_grejanje.data[typ_grejanje.value].korisnost);

    superconsole.log(
      "grejanje_gubici = temp.potrebna_energija * (1 - typ_grejanje.data[typ_grejanje.value].korisnost)"
    );

    superconsole.log(
      "grejanje_gubici = ",
      temp.final,
      " * (1 - ",
      typ_grejanje.data[typ_grejanje.value].korisnost,
      ")"
    );

    superconsole.log("grejanje_gubici = ", temp.grejanje_gubici);
    temp.final_grejanje = temp.final + temp.grejanje_gubici;

    superconsole.log("final_grejanje = temp.potrebna_energija + temp.grejanje_gubici;");

    superconsole.log("final_grejanje = ", temp.final, " + ", temp.grejanje_gubici);

    superconsole.log("final_grejanje = ", temp.final_grejanje);
    temp.primarno_grejanje =
      temp.final_grejanje * maxu.get_heating_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip);

    superconsole.log(
      "primarno_grejanje = temp.final_grejanje * maxu.get_heating_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip)"
    );

    superconsole.log(
      "primarno_grejanje = ",
      temp.final_grejanje,
      " * ",
      maxu.get_heating_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip)
    );

    superconsole.log("primarno_grejanje = ", temp.primarno_grejanje);
    temp.co2 =
      temp.primarno_grejanje * maxu.get_co2_koeficijent(loc_country_value, typ_grejanje.data[typ_grejanje.value].tip);
    temp.cena = temp.final_grejanje * mixins.data().typ_grejanje_cena_data_cfg[typ_grejanje.value];
    return final;
  },

  calculate_status_change: function (
    type,
    value,
    current_position,
    app_sklopovi,
    get_sklopovi_data,
    app_sklopovi_a,
    app_sklopovi_b,
    app_sklopovi_c,
    pos_standard,
    get_loc_u_max,
    pos_status,
    typ_dubina,
    typ_vrstatla,
    get_povrsine,
    top = {},
    bottom = {},
    emit_status = {},
    get_position_type = null
  ) {
    function get_top_sklop_data(top_param) {
      return helpers.get_top_sklop_data(
        app_sklopovi.data,
        top_param.image,
        top_param.debljina_zida,
        top_param.debljina_izolacije_default
      );
    }

    function get_bottom_sklop_data(bottom_param) {
      return helpers.get_top_sklop_data(app_sklopovi.data, bottom_param.image);
    }

    const pos_status_value = pos_status.value[current_position];
    if (get_position_type == null) {
      if (current_position == "10" || current_position == "13" || current_position == "60") {
        get_position_type = 2;
      } else if (current_position == "20" || current_position == "21") {
        get_position_type = 3;
      } else {
        get_position_type = 1;
      }
    }

    if (top.image == null) top.image = pos_status_value.top_image;
    if (top.debljina_zida == null) top.debljina_zida = Math.round(pos_status_value.top_debljina_zida * 100);
    if (top.debljina_izolacije == null)
      top.debljina_izolacije = Math.round(pos_status_value.top_debljina_izolacije * 100);
    if (top.debljina_izolacije_default == null)
      top.debljina_izolacije_default = Math.round(pos_status_value.top_debljina_izolacije_default * 100);
    if (top.window_type == null) {
      top.window_type = get_top_sklop_data(top).tip_prozora;
      bottom.window_type = top.window_type;
    }

    if (type === "default") {
      const top_sklop = get_top_sklop_data(top);
      if (pos_status_value.status == 0) {
        // OTVARA SE PRVI PUT
        // POSTAVLJANJE TOP I BOTTOM WINDOW TYPE I ZATIM BOTTOM SLIKE
        this.calculate_status_change(
          "bottom_image",
          {},
          current_position,
          app_sklopovi,
          get_sklopovi_data,
          app_sklopovi_a,
          app_sklopovi_b,
          app_sklopovi_c,
          pos_standard,
          get_loc_u_max,
          pos_status,
          typ_dubina,
          typ_vrstatla,
          get_povrsine,
          top,
          bottom,
          emit_status,
          get_position_type
        );
        if (get_position_type !== 2) {
          // POSTAVLJANJE BOTTOM IZOLACIJE TIP 1 ILI 3
          this.calculate_status_change(
            "bottom_debljina_izolacije",
            {},
            current_position,
            app_sklopovi,
            get_sklopovi_data,
            app_sklopovi_a,
            app_sklopovi_b,
            app_sklopovi_c,
            pos_standard,
            get_loc_u_max,
            pos_status,
            typ_dubina,
            typ_vrstatla,
            get_povrsine,
            top,
            bottom,
            emit_status,
            get_position_type
          );
        } else {
          // EMITOVANJE PODATAKA O SKLOPU - LAKA KONSTRUKCIJA, TIP PROZORA - TIP 2
          const sklop = top_sklop;
          emit_status.laka_konstrukcija = sklop.laka_konstrukcija;
          emit_status.tip_prozora = sklop.tip_prozora;
        }
      } else if (pos_status_value.status == 1) {
        // OTVARA SE PONOVO
        bottom.image = pos_status_value.bottom_image;
        bottom.debljina_izolacije = Math.round(pos_status_value.bottom_debljina_izolacije * 100);
        bottom.window_type = get_bottom_sklop_data(bottom).tip_prozora;
      }
    } else if (type === "top_image") {
      top.image = value.image == null ? get_sklopovi_data.sklopovi[current_position][0] : value.image;
      emit_status.top_image = top.image;
      if (get_position_type !== 2) {
        // IDE SE DALJE U PODESAVANJA
        this.calculate_status_change(
          "top_debljina_zida",
          value,
          current_position,
          app_sklopovi,
          get_sklopovi_data,
          app_sklopovi_a,
          app_sklopovi_b,
          app_sklopovi_c,
          pos_standard,
          get_loc_u_max,
          pos_status,
          typ_dubina,
          typ_vrstatla,
          get_povrsine,
          top,
          bottom,
          emit_status,
          get_position_type
        );
      } else {
        // POSTAVLJA SE BOTTOM SLIKA I KRAJ
        const sklop = get_top_sklop_data(top);
        emit_status.laka_konstrukcija = sklop.laka_konstrukcija;
        emit_status.tip_prozora = sklop.tip_prozora;
        if (pos_status_value.status != 1) {
          bottom.window_type = top.window_type;
        }
      }
      this.calculate_status_change(
        "bottom_image",
        {},
        current_position,
        app_sklopovi,
        get_sklopovi_data,
        app_sklopovi_a,
        app_sklopovi_b,
        app_sklopovi_c,
        pos_standard,
        get_loc_u_max,
        pos_status,
        typ_dubina,
        typ_vrstatla,
        get_povrsine,
        top,
        bottom,
        emit_status,
        get_position_type
      );
    } else if (type === "top_debljina_zida") {
      top.debljina_zida =
        value.debljina_zida == null ? helpers.get_top_debljina_zida(get_sklopovi_data, top.image) : value.debljina_zida;

      emit_status.top_debljina_zida = this.round(top.debljina_zida / 100, 2);
      this.calculate_status_change(
        "top_debljina_izolacije_default",
        value,
        current_position,
        app_sklopovi,
        get_sklopovi_data,
        app_sklopovi_a,
        app_sklopovi_b,
        app_sklopovi_c,
        pos_standard,
        get_loc_u_max,
        pos_status,
        typ_dubina,
        typ_vrstatla,
        get_povrsine,
        top,
        bottom,
        emit_status,
        get_position_type
      );
    } else if (type === "top_debljina_izolacije_default") {
      top.debljina_izolacije_default =
        value.debljina_izolacije_default == null
          ? helpers.get_top_debljina_izolacije(app_sklopovi_a.data, get_sklopovi_data, top.image, top.debljina_zida)
          : value.debljina_izolacije_default;
      emit_status.top_debljina_izolacije_default = this.round(top.debljina_izolacije_default / 100, 2);
      this.calculate_status_change(
        "top_debljina_izolacije",
        {},
        current_position,
        app_sklopovi,
        get_sklopovi_data,
        app_sklopovi_a,
        app_sklopovi_b,
        app_sklopovi_c,
        pos_standard,
        get_loc_u_max,
        pos_status,
        typ_dubina,
        typ_vrstatla,
        get_povrsine,
        top,
        bottom,
        emit_status,
        get_position_type
      );
    } else if (type === "top_debljina_izolacije") {
      top.debljina_izolacije =
        value.debljina_izolacije == null ? top.debljina_izolacije_default : value.debljina_izolacije;
      emit_status.top_debljina_izolacije = this.round(top.debljina_izolacije / 100, 2);
      const sklop = get_top_sklop_data(top);
      emit_status.laka_konstrukcija = sklop.laka_konstrukcija;
      emit_status.tip_prozora = sklop.tip_prozora;
      this.calculate_status_change(
        "bottom_debljina_izolacije",
        {},
        current_position,
        app_sklopovi,
        get_sklopovi_data,
        app_sklopovi_a,
        app_sklopovi_b,
        app_sklopovi_c,
        pos_standard,
        get_loc_u_max,
        pos_status,
        typ_dubina,
        typ_vrstatla,
        get_povrsine,
        top,
        bottom,
        emit_status,
        get_position_type
      );
    } else if (type === "bottom_image") {
      bottom.image =
        value.bottom_image == null
          ? get_position_type !== 2
            ? current_position === 7
              ? app_sklopovi_c.select[top.image]
                ? "c"
                : "b"
              : app_sklopovi_b.select[top.image]
              ? "b"
              : "c"
            : this.get_calculate_bottom_debljina(
                current_position,
                pos_status,
                typ_dubina,
                typ_vrstatla,
                get_povrsine.povrsina_jednog_sprata,
                get_povrsine.duzina_strane_kuce,
                get_loc_u_max,
                get_position_type,
                app_sklopovi,
                get_sklopovi_data,
                top,
                get_top_sklop_data(top),
                bottom.window_type
              ).sklop
          : value.bottom_image;
      bottom.image_key = bottom.image_key === 1 ? 2 : 1;
      emit_status.bottom_image = bottom.image;
    } else if (type === "bottom_debljina_izolacije") {
      const standard_array = this.get_standard_data_array(
        pos_standard,
        get_loc_u_max,
        current_position,
        pos_status,
        typ_dubina,
        typ_vrstatla,
        get_povrsine.povrsina_jednog_sprata,
        get_povrsine.duzina_strane_kuce,
        get_position_type,
        app_sklopovi,
        get_sklopovi_data,
        top,
        get_top_sklop_data(top),
        bottom.window_type
      );
      bottom.debljina_izolacije =
        value.bottom_debljina_izolacije == null ? this.get_izolacija(standard_array) : value.bottom_debljina_izolacije;
      emit_status.bottom_debljina_izolacije = this.round(bottom.debljina_izolacije / 100, 2);
    }

    return { top, bottom, emit_status };
  },

  get_izolacija: function (standard_array) {
    let elem = standard_array.find((x) => x[4] === "dark-green");
    if (elem != null) {
      return elem[0];
    }

    elem = standard_array.find((x) => x[4] === "green");
    if (elem != null) {
      return elem[1];
    }
    return 0;
  },
};
